import T from '@/components/Helpers/Translate'
import { Button } from '@/components/_ui/Button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/_ui/Popover'

import { copyTextToClipboard } from '@/lib/utils/shared/copyTextToClipboard'
import useGlobalStore from '@/store/useGlobalStore'

import Image from 'next/image'

import { useEffect, useState } from 'react'

import { cn } from '@/lib/utils'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'

export const Copy = ({
  isAccountPopover = false,
}: {
  isAccountPopover: boolean
}) => {
  const { user } = useGlobalStore()
  const { gtm } = useGTM()

  const [isUserIDCopied, setIsUserIDCopied] = useState(false)

  const handleCopy = () => {
    if (!user.customer?.id?.unicity) {
      return
    }

    copyTextToClipboard({ text: user.customer.id.unicity })
    gtm.userUnicityIdCopied(isAccountPopover ? 'profile_menu' : 'account_menu')

    mixpanelService
      .trackEvent(MixpanelEvent.USER_UNICITY_ID_COPIED, {
        event_location: isAccountPopover ? 'profile_menu' : 'account_menu',
      })
      .catch(() => {})

    setIsUserIDCopied(true)
  }

  useEffect(() => {
    if (!isUserIDCopied) return

    const timer = setTimeout(() => {
      setIsUserIDCopied(false)
    }, 3000)

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timer)
  }, [isUserIDCopied])

  const renderUserIDCopy = () => (
    <div className={cn('flex w-full')}>
      <div className="flex w-full justify-between">
        <Popover open={isUserIDCopied}>
          <PopoverTrigger>
            <Button onClick={handleCopy} size="icon" variant="icon">
              {isUserIDCopied ? (
                <Image
                  alt="copied"
                  height={20}
                  src="/icons/check.svg"
                  width={20}
                />
              ) : (
                <Image
                  alt="copy"
                  height={20}
                  src="/icons/copy.svg"
                  width={20}
                />
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent side="top" className="flex w-full justify-center">
            <p className="text-xs">
              <T>copied_to_clipboard</T>
            </p>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  )

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex text-sm">{user.customer?.id?.unicity}</div>
      {renderUserIDCopy()}
    </div>
  )
}
